export default __webpack_public_path__ + "static/media/image1.23ac1040.png";